import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { Reveal } from "../Reveal";
import { TESTIMONIALS, CONTACT } from "../../lib/data";

function Card({ t, featured }) {
  return (
    <div
      data-testid="testimonial-card"
      className={`relative break-inside-avoid overflow-hidden rounded-3xl border p-7 ${
        featured ? "border-gold/40 bg-gradient-to-br from-ink-surface to-[#181500]" : "border-ink-soft bg-ink-surface"
      }`}
    >
      <Quote className="h-8 w-8 text-gold/40" strokeWidth={1.5} />
      <div className="mt-4 flex gap-1 text-gold">
        {[...Array(t.rating)].map((_, i) => <Star key={i} className="h-4 w-4 fill-gold" strokeWidth={0} />)}
      </div>
      <p className="mt-4 leading-relaxed text-white/80">{t.text}</p>
      <div className="mt-6 flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-gold/15 font-display text-lg font-semibold text-gold">
          {t.name[0]}
        </div>
        <div>
          <div className="font-medium text-white">{t.name}</div>
          <div className="text-xs text-white/45">{t.role}</div>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative bg-ink py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div>
            <Reveal><span className="text-xs font-bold uppercase tracking-[0.3em] text-gold">Social Proof</span></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 max-w-2xl font-display text-4xl font-medium leading-tight tracking-tight sm:text-5xl lg:text-6xl">
                Loved by drivers across Lethbridge.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <div className="flex items-center gap-4 rounded-2xl glass px-6 py-4">
              <div className="font-display text-4xl font-semibold text-gold">{CONTACT.rating}</div>
              <div>
                <div className="flex gap-0.5 text-gold">
                  {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-gold" strokeWidth={0} />)}
                </div>
                <div className="mt-1 text-xs text-white/50">{CONTACT.reviews} Google reviews</div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="mt-16 columns-1 gap-6 md:columns-2 lg:columns-2 [&>*]:mb-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={i} delay={(i % 2) * 0.1}>
              <Card t={t} featured={i === 0} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
